export default __webpack_public_path__ + "static/media/clock-watch.bf2fe5d3.svg";